<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="700"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 21 }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="标题" prop="itemTitle">
        <a-input v-model="form.itemTitle" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="日期" prop="itemDate">
        <a-date-picker
          v-model="form.itemDate"
          placeholder="请选择日期"
          style="width: calc(100% - 230px); margin-right: 10px"
          @change="changeDate1"
        />
        <a-input
          v-model="diffDay"
          disabled
          addon-before="距高考结束天数"
          addon-after="天"
          style="width: 220px; margin-bottom: 2px"
        />
      </a-form-model-item>
      <a-form-model-item label="开放状态" prop="isOpen">
        <a-select
          v-model="form.isOpen"
          placeholder="请选择开放状态"
          :options="[
            { label: '开放', value: true },
            { label: '关闭', value: false },
          ]"
        />
      </a-form-model-item>
      <a-form-model-item label="心灵鸡汤">
        <a-textarea
          v-model="form.itemIntro"
          placeholder="请输入心灵鸡汤"
          :auto-size="{ minRows: 4, maxRows: 8 }"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction, putAction } from '@/api/manage'
import { getStoreFileUrl } from '@/utils/util'
import moment from 'moment'
import { getDateDiff } from '@/utils/util'

export default {
  name: 'CreateCourseOath',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '创建课程',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        itemTitle: [{ required: true, message: '请输入标题', trigger: 'change' }],
        itemDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
        isOpen: [{ required: true, message: '请选择是否开放', trigger: 'change' }],
        itemIntro: [{ required: true, message: '请输入心灵鸡汤', trigger: 'change' }],
      },
      // uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=studentTag',
      fileList: [],
      templateUrl: '',
      diffDay: 0,
    }
  },
  methods: {
    showModal(data = {}) {
      console.log('')
      this.form = data
      if (data?.itemDate) {
        this.diffDay = getDateDiff(data.itemDate, data.endDate)
      }
      console.log('数据：', data)
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.fileList = []
      this.diffDay = 0
    },
    async handleOk() {
      const params = {
        ceremonyId: this.form.ceremonyId,
        ceremonyItemId: this.form.ceremonyItemId,
        id: this.form.id,
        contentType: this.form.contentType,
        itemTitle: this.form.itemTitle,
        itemDate: moment(this.form.itemDate).format('YYYY-MM-DD'),
        itemIntro: this.form.itemIntro,
        isOpen: this.form.isOpen,
      }
      console.log('参数', params)
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const res = this.form.ceremonyItemId
            ? await putAction('/ceremonyItem/edit', params)
            : await postAction('/ceremonyItem/add', params)
          if (res.success) {
            this.$message.success(res.message)
            this.hideModal()
            this.$emit('refreshData')
          } else {
            this.$message.error(res.message || '保存失败')
          }
        }
      })
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
      console.log('fileList', fileList)
    },
    changeDate1(date) {
      this.diffDay = getDateDiff(moment(date).format('YYYY-MM-DD'), this.form.endDate)
      console.log('date', moment(date).format('YYYY-MM-DD'))
      console.log('this.form.endDate', moment(this.form.endDate).format('YYYY-MM-DD'))
      console.log('diffDay', this.diffDay)
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px 10px;
  }
  /deep/ .ant-upload {
    height: 149px;
  }
}
</style>
